import { create } from 'zustand';

const initialState = {
    selectedPatient: null,
    equipmentList: [],
    collectionSelected: {},
    configuredCollections: [],
};

// Restored store used by the existing collection flow.
export const useCollectionStore = create((set, get) => ({
    ...initialState,
    setSelectedPatient: (selectedPatient) => set({ selectedPatient }),
    setEquipmentList: (equipmentList) => set({ equipmentList: equipmentList ?? [] }),
    setCollectionSelected: (collectionSelected) =>
        set({ collectionSelected: collectionSelected ?? {} }),
    setConfiguredCollection: (configuredCollections) =>
        set({ configuredCollections: configuredCollections ?? [] }),
    getKeptItems: () =>
        (get().equipmentList ?? []).map((equipment) => ({
            ...equipment,
            collect: Boolean(get().collectionSelected?.[equipment.id]?.parent),
        })),
    reset: () => set({ ...initialState }),
}));
